




































































import Broadcast from '@/types/Broadcast.interface'
import Button from '@/types/components/Button.interface'
import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    props: {
        broadcast: {
            type: Object as PropType<Broadcast>,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        open: false
    }),
    computed: {
        ...mapGetters(['getEnabled', 'getLimit', 'productTier', 'trialing']),
        a2pEnabled(): boolean {
            //  Check if A2P is enabled
            return this.getEnabled('a2p')
        },
        broadcastLimit(): number {
            //  Grab our limits
            return this.getLimit('broadcast') || 250
        },
        broadcastLimitReached(): boolean {
            //  If a2p is enabled, return false because we have no limits
            if (this.a2pEnabled) return false

            //  Else check the persons count
            const count = this.contactsCount

            //  Check if the count exceeds current limit
            return count > this.broadcastLimit
        },
        buttons(): Button[] {
            return [
                {
                    text: 'Send Test',
                    color: 'primary',
                    callback: () => this.sendTest()
                },
                {
                    text: 'Schedule',
                    color: 'primary',
                    callback: () => this.schedule()
                },
                {
                    text: 'Send Now',
                    color: 'primary',
                    callback: () => this.send()
                }
            ]
        },
        contactsCount(): number {
            return this.$store.getters.broadcastsViewSelectedBroadcastTotalCount
        }
    },
    methods: {
        save(): void {
            this.$emit('save')
        },
        saveDraft(): void {
            this.$emit('saveDraft', true)
        },
        // saveTemplate(): void {
        //     console.log('save template')
        // },
        sendTest(): void {
            this.$emit('test')
        },
        schedule(): void {
            this.$emit('schedule')
        },
        send(): void {
            this.$emit('submit')
        }
    }
})
